"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEnrolledError = exports.LOYALTY_NOT_ENROLLED_CODE = void 0;
/**
 * `blaze-loyalty-service` answers a profile read for a non-enrolled customer with
 * HTTP 400 and this envelope (see its `ResponseWriter.generateErrorMessage`):
 *
 *   { "error": "<detail>", "errors": [{ "code": "loyalty_not_enrolled", ... }] }
 *
 * It goes through `http-errors`, which carries that JSON as a string message, so the
 * payload can arrive parsed, stringified, or nested under `message`. Matching the
 * structured code rather than the raw body keeps a 500 that merely mentions the code
 * from being read as "not enrolled".
 */
exports.LOYALTY_NOT_ENROLLED_CODE = 'loyalty_not_enrolled';
const NOT_ENROLLED_STATUS = 400;
const isRecord = (value) => typeof value === 'object' && value !== null;
const parseJson = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (error) {
        return undefined;
    }
};
const readEnvelope = (data) => {
    if (typeof data === 'string') {
        const parsed = parseJson(data);
        return isRecord(parsed) ? parsed : undefined;
    }
    if (!isRecord(data)) {
        return undefined;
    }
    if (Array.isArray(data.errors)) {
        return data;
    }
    // `http-errors` puts the serialized envelope in `message`.
    return typeof data.message === 'string' ? readEnvelope(data.message) : data;
};
const hasNotEnrolledCode = (envelope) => {
    const { errors } = envelope;
    if (!Array.isArray(errors)) {
        return false;
    }
    return errors.some((entry) => isRecord(entry) && entry.code === exports.LOYALTY_NOT_ENROLLED_CODE);
};
const isNotEnrolledError = (error) => {
    const response = error === null || error === void 0 ? void 0 : error.response;
    if (!response || response.status !== NOT_ENROLLED_STATUS) {
        return false;
    }
    const envelope = readEnvelope(response.data);
    return !!envelope && hasNotEnrolledCode(envelope);
};
exports.isNotEnrolledError = isNotEnrolledError;
//# sourceMappingURL=errors.js.map